<tabs-inner-wrap>
  <simulation-prompts></simulation-prompts>
</tabs-inner-wrap>
